/** Branded full-screen auth backdrop: forest gradient + gold wordmark. */
export function AuthShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gradient-to-b from-[var(--color-forest-light)] via-[var(--color-forest)] to-[var(--color-forest-dark)]">
      <div className="mb-8 text-center">
        <p className="font-serif text-2xl font-semibold tracking-tight text-[var(--color-gold)]">
          XYZ Strategy
        </p>
        <p className="mt-1 text-xs uppercase tracking-[0.18em] text-[var(--color-soft-gray)]">
          Operations &amp; Finance
        </p>
      </div>
      {children}
    </div>
  );
}
